<template>
  <div style="width: 100%;height: 100%;text-align: center">
    <el-scrollbar style="height: 100%">
      <div style="font-size: 26px;margin-top: 10px;"><strong>论文专著目录</strong>（不超过8篇）</div>
      <el-table
        :data="tableData"
        border
        :cell-style="{borderColor:'#4a4a4a'}"
        :header-cell-style="{borderColor:'#4a4a4a'}"
        style="width: 100%;margin-top: 15px;"
        :row-class-name="tableRowClassName">
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="论文专著名称/刊名/作者"
          width="260"
          align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" v-model="scope.row.name" type="textarea" rows=3></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="divisor"
          label="影响因子"
          width="70"
          align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" v-model="scope.row.divisor" type="textarea" rows=3 @input="(val)=>{scope.row.divisor = limitDecimalInputWithDigit(val, 6)}"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="page"
          label="年卷页码（xx年xx卷xx页）"
          align="center"
          width="190"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" v-model="scope.row.page" type="textarea" rows=3></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="postedtime"
          label="发表时间"
          align="center"
          width="140"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-date-picker
              :readonly="isDisabled"
              v-model="scope.row.postedtime"
              type="date"
              size="small"
              style="width: 130px"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="correspondingauthor"
          label="通讯作者"
          align="center"
          width=""
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" v-model="scope.row.correspondingauthor" type="textarea" rows=3></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="firstauthor"
          label="第一作者"
          align="center"

          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" v-model="scope.row.firstauthor" type="textarea" rows=3></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="sciorei"
          label="SCI/EI"
          align="center"
          width="80"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" v-model="scope.row.sciorei" type="textarea" rows=3></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="corejournal"
          label="核心期刊"
          align="center"
          width="150"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input :readonly="isDisabled" v-model="scope.row.corejournal" type="textarea" rows=3></el-input>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!isDisabled"
          label="操作"
          align="center"
          show-overflow-tooltip
          width="70">
          <template slot-scope="scope">
            <i v-if="tableData.length<8" class="el-icon-circle-plus-outline" @click="onAddRow(scope.$index)" style="cursor: pointer"></i>
            <i class="el-icon-remove-outline" @click="onDeleteRow(scope.$index)" style="cursor: pointer"></i>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: left;">承诺：上述论文专著用于报奖的情况，已征得未列入项目主要完成人的作者同意。上述论文专著知识产权归国内所有，且不存在争议。</div>
      <div v-if="!isDisabled" style="width: 100%;margin-top: 20px;">
        <el-button :disabled="isSubmit" type="primary" @click="onSubmit">保存</el-button>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import utils from "../../js/utils";

export default {
  name: "Thesis_08",
  data() {
    return {
      createuserid: sessionStorage.getItem('createuserid'),
      isDisabled: sessionStorage.getItem('openWith') == 'readOnly' ? true : false,
      tableData: [{
        name: '',
        divisor: '',
        page: '',
        postedtime: '',
        correspondingauthor: '',
        firstauthor: '',
        sciorei: '',
        corejournal: '',
        state: false
      }],
      deleteList: [],
      buchong: '',
      duplicateCheckingTableData:[],
      isSubmit: false
    }
  },
  methods: {
    onAddRow(index) {
      this.tableData.splice(index + 1, 0, {
        name: '',
        divisor: '',
        page: '',
        postedtime: '',
        correspondingauthor: '',
        firstauthor: '',
        sciorei: '',
        corejournal: '',
        state: false
      })
    },
    onDeleteRow(index) {
      if (this.tableData[index].state) {
        this.deleteList.push({paperid: this.tableData[index].paperid})
      }
      this.tableData.splice(index, 1);
      if (!this.tableData.length) {
        this.tableData.push({
          name: '',
          divisor: '',
          page: '',
          postedtime: '',
          correspondingauthor: '',
          firstauthor: '',
          sciorei: '',
          corejournal: '',
          state: false
        })
      }
    },
    getData() {
      if (sessionStorage.getItem("pbcid") == undefined) {
        return
      }
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/common/selectprojectpaper',
        params: {
          pbcid: Number(sessionStorage.getItem('pbcid'))
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          if (resp.data.length) {
            this.tableData = resp.data;
            this.tableData.forEach((item, index) => {
              this.tableData[index].state = true
            });
          }
          this.deleteList = []
          if (resp.data.length!==0&&this.createuserid==0) {
            this.duplicateChecking()
          }
          this.closeLoading();
        } else {
          this.closeLoading();
          this.showFailMsg(resp.message)
        }
      })
    },
    duplicateChecking() {
      let CheckPaperDTO = []
      let tempObj = {}
      this.tableData.forEach((obj, index) => {
        tempObj = {
          name: obj.name,
          rank: index,
          pbcid: Number(sessionStorage.getItem('pbcid'))
        }
        CheckPaperDTO.push(tempObj)
      })
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/admin/checkpaper',
        data: CheckPaperDTO
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.duplicateCheckingTableData = resp.data
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    tableRowClassName({row, rowIndex}) {
      if(this.duplicateCheckingTableData.find(obj=>obj.rank==rowIndex)){
        return 'warning-row';
      }
      return '';
    },
    onSubmit() {
      if(this.tableData.length==1 && (this.tableData[0].name==='' && this.tableData[0].divisor==='' && this.tableData[0].page==='' && this.tableData[0].postedtime==='' && this.tableData[0].correspondingauthor==='' && this.tableData[0].firstauthor==='' && this.tableData[0].sciorei==='' && this.tableData[0].corejournal==='')) {
        this.openLoading("内容提交中","提交失败，请检查网络",7000);
        this.$axios({
          method: 'post',
          url: this.GLOBAL.URL + 'pingjiang/user/updateprojectpaper',
          data: {
            pbcid: Number(sessionStorage.getItem('pbcid')),
            addList: [],
            updateList: [],
            deleteList: this.deleteList,
          }
        }).then((res) => {
          let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
          this.isSubmit = false;
          if (resp.code == 1000) {
            this.showSuccessMsg(resp.message);
            this.getData();
          } else {
            this.showFailMsg(resp.message)
          }
        })
      } else {
        for (let i = 0; i < this.tableData.length; i++) {
          if(this.tableData[i].name===''||this.tableData[i].divisor===''||this.tableData[i].page===''||this.tableData[i].postedtime===''||this.tableData[i].correspondingauthor===''||this.tableData[i].firstauthor===''||this.tableData[i].sciorei===''||this.tableData[i].corejournal===''){
            this.showNotifyError('请完善表格数据！');
            return ;
          }
        }
        this.openLoading("内容提交中","提交失败，请检查网络",7000);
        let addList = [];
        let updateList = [];
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].state) {
            updateList.push({
              pbcid: Number(sessionStorage.getItem('pbcid')),
              paperid: this.tableData[i].paperid,
              name: this.tableData[i].name,
              divisor: this.tableData[i].divisor,
              page: this.tableData[i].page,
              postedtime: this.tableData[i].postedtime,
              correspondingauthor: this.tableData[i].correspondingauthor,
              firstauthor: this.tableData[i].firstauthor,
              sciorei: this.tableData[i].sciorei,
              corejournal: this.tableData[i].corejournal
            })
          } else {
            addList.push({
              pbcid: Number(sessionStorage.getItem('pbcid')),
              name: this.tableData[i].name,
              divisor: this.tableData[i].divisor,
              page: this.tableData[i].page,
              postedtime: this.tableData[i].postedtime,
              correspondingauthor: this.tableData[i].correspondingauthor,
              firstauthor: this.tableData[i].firstauthor,
              sciorei: this.tableData[i].sciorei,
              corejournal: this.tableData[i].corejournal
            })
          }
        }
        this.$axios({
          method: 'post',
          url: this.GLOBAL.URL + 'pingjiang/user/updateprojectpaper',
          data: {
            pbcid: Number(sessionStorage.getItem('pbcid')),
            addList: addList,
            updateList: updateList,
            deleteList: this.deleteList,
          }
        }).then((res) => {
          let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
          this.isSubmit = false;
          if (resp.code == 1000) {
            this.showSuccessMsg(resp.message);
            this.getData();
          } else {
            this.showFailMsg(resp.message)
          }
        })
      }
    },
  },
  created() {
    this.getData()
  },
  mounted() {
    if (sessionStorage.getItem('pbcid') == undefined) {
      this.$message.error('请先填写项目基本情况表');
      this.$router.push({
        path: '/HomePage/PJGLHomepage/projectHomePage/PrimaryInfo_01'
      })
    }
    if(this.createuserid==0){
      this.$notify({
        title: '提示',
        message: '红色背景为可能存在重复的论文',
        duration: 6000
      });
    }
  }
}
</script>
<style>
.el-table .warning-row {
  background: rgb(253, 226, 226);
}
.el-table .warning-row input{
  background: rgb(253, 226, 226);
}
.el-table .warning-row textarea{
  background: rgb(253, 226, 226);
}
</style>
<style scoped>
/deep/ .el-scrollbar__wrap {
  overflow: hidden scroll;
  height: 100%;
}

/deep/ .el-table .el-table__cell {
  padding: 0px;
}

/deep/ .el-table .cell {
  padding: 5px 3px;
}

/deep/ .el-table th.el-table__cell > .cell {
  padding: 16px 5px;
}

/deep/ .el-textarea__inner {
  resize: none;
  padding: 0;
  border: none;
}

.el-table {
  border: 1px solid #4a4a4a;
}

/deep/ .el-input__inner {
  border: none;
}

</style>



// WEBPACK FOOTER //
// src/views/PJGL/ProjectSequence/Thesis_08.vue